export default [
    {
        name: 'word',
        sortField: 'word',
        type: 'string',
        callback: 'similarKeyWord',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: '__slot:pos',
        sortField: 'pos',
        type: 'number',
        dataClass: 'ral pos',
        useInFilter: true,
    },
    {
        name: 'frequency',
        sortField: 'ws',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        isDefault: true,
        useInFilter: true,
    },
    {
        name: 'numwords',
        sortField: 'numwords',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'serpf',
        sortField: 'serp',
        type: 'string',
        dataClass: 'ral',
        useInFilter: false,
    }
]
